import {EVENT_CATEGORY, EVENT_ACTIONS} from './edapEventsConstantsLegacy';
import {triggerEdapEventLegacy, getLabel} from './edapHelpersLegacy';

/**
 * Triggers EDAP event when a card shows up in the view
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {number} position - card position in carousel (basically its index)
 *     @property {string} lid - hit.listingId, for example, 121.302.120
 *     @property {string} card_title - hit.headline
 *     @property {string} card_text - hit.accommodations
 *     @property {string} im_url - hit.imageUrl
 * }
 */

export function propertyCardViewEvent(context, labelData = {}) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CARD_VIEW,
            ...getLabel(labelData),
        },
    });
}

/**
 * Triggers EDAP event when a user clicks on a card
 * @param context {@link CarouselContainer.contextType}
 * @param {object} labelData - Object used by {@link getLabel} to generate 'eventlabel' {
 *     @property {string} rrm - clientRequestId AKA X-HomeAway-RequestMarker header
 *     @property {number} position - card position in carousel (basically its index)
 *     @property {string} lid - hit.listingId, for example, 121.302.120
 *     @property {string} link - hit.propertyHref
 * }
 */

export function propertyCardClickEvent(context, labelData = {}) {
    triggerEdapEventLegacy(context, {
        fields: {
            ...EVENT_CATEGORY,
            ...EVENT_ACTIONS.CLICK,
            ...getLabel(labelData),
        },
    });
}

export function destinationCardClickEvent(context, labelData = {}) {
    triggerEdapEventLegacy(context, {
        event: 'destination.link.click',
        fields: {
            ...labelData,
        },
    });
}
